var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCandidateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.40426,
    cy: 3.40426,
    r: 3.40426,
    transform: "matrix(-1 0 0 1 15.6171 5)",
    stroke: "#ECEDEF",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25537 16.8604C6.25537 16.1282 6.71567 15.475 7.40524 15.2287V15.2287C10.5141 14.1184 13.9115 14.1184 17.0204 15.2287V15.2287C17.71 15.475 18.1703 16.1282 18.1703 16.8604V17.98C18.1703 18.9905 17.2752 19.7668 16.2748 19.6239L15.9412 19.5763C13.4682 19.223 10.9575 19.223 8.48442 19.5763L8.15087 19.6239C7.15044 19.7668 6.25537 18.9905 6.25537 17.98V16.8604Z",
    stroke: "#ECEDEF",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3191 11.9042C18.7964 11.9042 19.9939 10.7067 19.9939 9.22946C19.9939 7.75222 18.7964 6.55469 17.3191 6.55469",
    stroke: "#ECEDEF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2486 18.0075L20.5106 18.0449C21.2967 18.1572 22 17.5473 22 16.7533V15.8736C22 15.2983 21.6383 14.7851 21.0965 14.5916C20.5561 14.3985 20.0045 14.2482 19.4468 14.1406",
    stroke: "#ECEDEF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.68088 11.9042C5.20364 11.9042 4.0061 10.7067 4.0061 9.22946C4.0061 7.75222 5.20364 6.55469 6.68088 6.55469",
    stroke: "#ECEDEF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75143 18.0075L3.48935 18.0449C2.7033 18.1572 2.00003 17.5473 2.00003 16.7533V15.8736C2.00003 15.2983 2.3617 14.7851 2.9035 14.5916C3.44395 14.3985 3.99549 14.2482 4.55322 14.1406",
    stroke: "#ECEDEF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandidateIcon);
export default __webpack_public_path__ + "static/media/CandidateIcon.1b5adc63c90fd00d912ea0c029694825.svg";
export { ForwardRef as ReactComponent };